import { Button, Stack } from '@mui/joy';
import { X } from '@phosphor-icons/react';
import { UseFieldArrayReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { corporateRegionService } from 'corporate/services';
import { IPricingProfileAccessForm } from 'pricing/components';
import { Color, Direction, Variant } from 'theme/enums';

interface IProps {
  regions: UseFieldArrayReturn<IPricingProfileAccessForm, 'regions'>;
}

export const RegionsField = ({ regions }: IProps) => {
  const { t } = useTranslation();
  const { control, errors, setValue } = useFormContext();

  const onRemove = (index: number) => {
    if (regions.fields.length === 1) {
      setValue('allRegions', true);
    }

    regions.remove(index);
  };

  return (
    <>
      {regions.fields.map((regionField, index) => (
        <Stack key={regionField.id} direction={Direction.ROW} spacing={1}>
          <FormField
            name={`regions.${index}.region`}
            type={InputType.AUTOCOMPLETE}
            wrapperStyle={{ flex: 1 }}
            inputProps={{
              control,
              error: errors.regions?.[index]?.region,
              placeholder: t('placeholderSelectRegion'),
              getOptions: corporateRegionService.getRegionsAutocomplete,
              disableClearable: true,
            }}
          />
          <Button variant={Variant.PLAIN} color={Color.DANGER} onClick={() => onRemove(index)}>
            <X />
          </Button>
        </Stack>
      ))}
    </>
  );
};
